import { render, staticRenderFns } from "./PickupDetail.vue?vue&type=template&id=32dca9e0&scoped=true&"
import script from "./PickupDetail.vue?vue&type=script&lang=js&"
export * from "./PickupDetail.vue?vue&type=script&lang=js&"
import style0 from "./PickupDetail.vue?vue&type=style&index=0&id=32dca9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dca9e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
